import React, { useMemo } from 'react';
import { withTheme } from 'styled-components';
import LineScoreDecisions from './final/LineScoreDecisions';
import { FinalMiniLinescoreWrapper, FinalMiniTopWrapper } from './FinalMini.style';
import TeamSummaryMatchupDataContainer from '../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';
import TopPerformersDataContainer from '../TopPerformers/containers/TopPerformersDataContainer';

const trackingConfig = ['Final', 'TeamSummaryMatchup'];
const FinalMini = ({
    isMobile
}) => {
    const isSingleColumnWide = false;
    const twoColumnExpandView = !isMobile;
    const expandView = isSingleColumnWide || twoColumnExpandView;

    const teamSummaryMatchup = useMemo(() => {
        return (
            <FinalMiniTopWrapper>
                <TeamSummaryMatchupDataContainer
                    displayRecords={true}
                    displayStandings={expandView}
                    logoSize={expandView ? '48' : '32'}
                    scoreSize={expandView ? '40px' : '32px'}
                    useTri={!expandView}
                    displayGameStateSubtitle={true}
                    componentName={trackingConfig}
                />
                <FinalMiniLinescoreWrapper $expanded={expandView} $singleColumnExpandView={isSingleColumnWide} $twoColumnExpandView={twoColumnExpandView} >
                    <LineScoreDecisions stacked={ !expandView } sidePadding={ expandView ? '' : '16px' } useFullName={twoColumnExpandView}/>
                </FinalMiniLinescoreWrapper>
            </FinalMiniTopWrapper>
        );
    }, [expandView, twoColumnExpandView]);

    return (
        <>
            {teamSummaryMatchup}
            <TopPerformersDataContainer isMobile={ true } viewType={'mini'} />
        </>
    );
};

export default withTheme(FinalMini);
